// Types
// Components
import HistoryTime from 'components/HistoryTime';
import _ from 'lodash';
import type { TReservationMode } from '@timeedit/types/lib/types';
import { TEDrawerSection, TEInput } from '@timeedit/ui-components';

export interface InfoProps {
  data: TReservationMode;
  onChange: (key: string, value: any) => void;
}

const Info = (props: InfoProps) => {
  const { data, onChange } = props;
  return (
    <TEDrawerSection label="General info">
      <div className="wrapper-section">
        <div className="section-item">
          <TEInput.Input
            label="Name"
            tooltip="Name"
            value={data.name}
            onChange={(val) => onChange('name', val)}
            placeholder="New Reservation Mode"
            data-testid="reserv-name"
          />
          <TEInput.TextArea
            label="Description"
            tooltip="Description"
            value={data.description}
            onChange={(val) => onChange('description', val)}
            data-testid="reserv-desc"
          />
        </div>
        <div className="section-item">
          <TEInput.Input
            label="ExtId"
            tooltip="ExtId"
            value={data.extId}
            onChange={(val) => onChange('extId', val)}
            placeholder="ExtId"
            data-testid="reserv-extId"
          />
          <TEInput.PureText label="Id" tooltip="Id" value={`${data.id}`} />
          <HistoryTime history={data?.history} />
        </div>
      </div>
    </TEDrawerSection>
  );
};

export default Info;
